@if (_context) {
    <mat-tab-group class="detail-tabs">
        <mat-tab label="Infos">
            <app-view-form
                [disabled]="_context.formMode === FormMode.Reading"
                [context]="_context.viewContext"
                [view]="_context.viewContext.view"
                (viewUpdated)="onViewUpdated($event)"
                (canceled)="onCanceled($event)"></app-view-form>
        </mat-tab>
        @if (!!_context.viewContext.view.id && displayAccessibilities) {
            <mat-tab label="Accessibilité">
                <app-view-accessibility
                    [view]="_context.viewContext.view"
                    [disabled]="_context.formMode === FormMode.Reading"
                    (accessibilitiesUpdated)="onAccessibilitiesUpdated($event)"
                    (canceled)="onCanceled($event)"></app-view-accessibility>
            </mat-tab>
        }
    </mat-tab-group>
}
